import React, { useState, useEffect } from "react";
import { ProgressBar } from "react-bootstrap";

export default function Progress(props) {
  let count = props.value;

  useEffect(() => {
    var timer;
    var time = props.grid ? 100 : 1000;
    function update() {
      props.setProgressPercentage(count++);
    }

    (function repeat() {
      if (count % 10 == 0) {
        time *= 2;
      }
      update();

      timer = setTimeout(repeat, time);
    })();
    return () => {
      props.setProgressPercentage(0);
      clearTimeout(timer);
    };
  }, [count]);
  return (
    <>
      {props.loadingMessage == "Fetching Result" ? (
        <div
          className="ag-custom-loading-cell"
          style={{
            lineHeight: "25px",
            width: "500px",
            background: "white",
            border: "1px solid black",
          }}
        >
          <ProgressBar
            variant={"info"}
            animated
            now={100}
            animated
            label={props.loadingMessage}
          />
          <i className="fas fa-spinner fa-pulse"></i>{" "}
        </div>
      ) : (
        <div
          style={
            props.grid
              ? {
                  height: "100px",
                  width: "500px",
                }
              : {}
          }
        >
          {!props.stop ? (
            <ProgressBar
              style={{
                height: "30px",
                fontSize: "1em",
              }}
              variant={props.percent >= 90 ? "success" : "info"}
              animated
              now={props.percent >= 90 ? "100" : props.percent}
              label={`${props.percent > 90 ? 100 : props.percent} %`}
            />
          ) : (
            <ProgressBar
              style={{
                height: "30px",
                fontSize: "1em",
              }}
              variant={"success"}
              animated
              now={props.percent2}
              label={`${props.percent2}%`}
            />
          )}
        </div>
      )}
    </>
  );
}

{
}
